import { domainSignal } from "@/utils/domain-store";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";

export default function DownlandPage({ companyData }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const title = localStorage.getItem("title");
  return (
    <div className="px-4 py-6 text-white">
      {/* 顶部横幅图片 */}
      <div className="w-full mb-8">
        <img
          src={imageConfig.baseImageUrl + companyData?.logo1}
          className="w-full h-auto rounded-xl object-cover shadow-lg"
          alt="Banner"
        />
      </div>

      {/* 下载选项区域 */}
      <div className="space-y-4">
        {/* iOS 下载选项 */}
        <div className="bg-neutral-800 rounded-xl p-4 flex items-center justify-between shadow-card transition-all hover:bg-neutral-700">
          <div className="flex items-center space-x-4">
            <img
              className="w-16 h-16 rounded-lg object-cover"
              src={imageConfig.baseImageUrl + companyData?.companyLogo}
              alt="iOS App"
            />
            <div>
              <h2 className="text-xl font-bold text-white">iOS</h2>
              <p className="text-neutral-400 text-sm">
                {translate(getText("年齡"))} 5+
              </p>
              <p className="text-neutral-400 text-sm">
                {translate(getText("提供安全"))}，
                {translate(getText("便捷的買賣方式"))}
              </p>
            </div>
          </div>
          {domainSignal.value.appStatus === 1 && (
            <button
              className="bg-primary hover:bg-primary-light text-black px-6 py-2 rounded-lg transition-colors"
              onClick={() => {
                if (companyData?.iosDomain.includes("http")) {
                  window.location.href = companyData?.iosDomain;
                }
              }}
            >
              {translate(getText("下載"))}
            </button>
          )}
        </div>

        {/* Android 下载选项 */}
        <div className="bg-neutral-800 rounded-xl p-4 flex items-center justify-between shadow-card transition-all hover:bg-neutral-700">
          <div className="flex items-center space-x-4">
            <img
              className="w-16 h-16 rounded-lg object-cover"
              src={imageConfig.baseImageUrl + companyData?.companyLogo}
              alt="Android App"
            />
            <div>
              <h2 className="text-xl font-bold text-white">Android</h2>
              <p className="text-neutral-400 text-sm">
                {translate(getText("年齡"))} 5+
              </p>
              <p className="text-neutral-400 text-sm">
                {translate(getText("提供安全"))}，
                {translate(getText("便捷的買賣方式"))}
              </p>
            </div>
          </div>
          {domainSignal.value.appStatus === 1 && (
            <button
              className="bg-primary hover:bg-primary-light text-black px-6 py-2 rounded-lg transition-colors"
              onClick={() => {
                if (companyData?.androidDomain.includes("http")) {
                  window.location.href = companyData?.androidDomain;
                }
              }}
            >
              {translate(getText("下載"))}
            </button>
          )}
        </div>

        {/* <div className="bg-neutral-800 rounded-xl p-4 flex items-center justify-between shadow-card transition-all hover:bg-neutral-700">
          <div className="flex items-center space-x-4">
            <img
              className="w-16 h-16 rounded-lg object-cover"
              src={imageConfig.baseImageUrl + companyData?.companyLogo}
              alt="Android App"
            />
            <div>
              <h2 className="text-xl font-bold text-white">PWA</h2>
              <p className="text-neutral-400 text-sm">
                {translate(getText("年齡"))} 5+
              </p>
              <p className="text-neutral-400 text-sm">
                {translate(getText("提供安全"))}，
                {translate(getText("便捷的買賣方式"))}
              </p>
            </div>
          </div>
          <button
            className="bg-primary hover:bg-primary-light text-black px-6 py-2 rounded-lg transition-colors"
            onClick={() => {
              if (isPwaInstallable()) {
                installPwa();
              }
            }}
          >
            {translate(getText("下載"))}
          </button>
        </div> */}
      </div>

      {/* 介绍区域 */}
      <div className="mt-10 bg-neutral-800 rounded-xl p-5 shadow-card">
        <h2 className="text-xl font-bold text-white mb-4">
          {translate(getText("介紹"))}
        </h2>
        <p className="text-neutral-300 leading-relaxed">
          {translate(
            getText(
              "作為一家公司，我們強調長期的安全性、可靠性和便利性。我們的主要產品和服務反映了這一願景。先進的交易平台,更低的消費，更安全高效的保障，我們讓每個人都能輕鬆擁有和交易資產"
            )
          )}
        </p>
      </div>
    </div>
  );
}
